import React, { useEffect, useRef } from "react";
import Container from "../../UI/Container/Container";
import classes from "./Message.module.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Message = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const textRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 50%",
      },
    });

    timeline.to(textRef.current, { opacity: 1, duration: 1, ease: "sine.out" });
  });

  return (
    <div className={classes.Message}>
      <Container>
        <p ref={textRef}>
            When you’re considering a college, it’s important to know what that
            college stands for. What it’s known for. What it excels at. For us,
            it’s a collegewide and lifelong commitment to global education,
            sustainability and civic engagement.
          </p>
      </Container>
    </div>
  );
};

export default Message;
